import React from 'react';
import { Section } from './ui/Section';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const pains = ["Te sientas a 'trabajar' y terminas el día con 20 cosas empezadas y 0 terminadas.", 'Guardaste plantillas, viste videos, abriste Notion… y aun así no publicaste tu página.', "Sientes que 'necesitas un embudo', pero cada tutorial te mete más pasos.", 'Quieres vender, pero te falta una ruta clara: de atención → a pago.'];
  return <Section className="bg-section" data-id="element-136">
      <div className="text-center mb-12" data-id="element-137">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-138">
          Si esto te está pasando…
        </h2>
        <div className="h-1 w-20 bg-accent-blue mx-auto rounded-full" data-id="element-139" />
      </div>

      <div className="grid gap-6 max-w-3xl mx-auto" data-id="element-140">
        {pains.map((pain, index) => <div key={index} className="flex items-start p-6 bg-primary rounded-xl border border-white/5 hover:border-red-500/30 transition-colors" data-id="element-141">
            <XCircle className="w-6 h-6 text-red-500 mt-1 mr-4 flex-shrink-0" data-id="element-142" />
            <p className="text-lg text-text-secondary" data-id="element-143">{pain}</p>
          </div>)}
      </div>

      <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-144">
        <p className="text-xl font-medium text-white mb-2" data-id="element-145">
          No necesitas más información.
        </p>
        <p className="text-xl text-accent-blue" data-id="element-146">
          Necesitas una estructura mínima que te obligue a ejecutar.
        </p>
      </div>
    </Section>;
}